import React from 'react';

import { ReservationDetailsCard } from '../reservation-details-card';

import {
  CheckInSettings,
  ReservationWithRateDetailsDTO,
  Settings,
} from '@/models';

import { VStack } from '@ui-library';

interface ReservationListProps {
  reservations: ReservationWithRateDetailsDTO[];
  primaryColor: string;
  companyTimezone: string;
  checkInSettings: CheckInSettings | null;
  settings?: Settings;
  onClick?: (reservation: ReservationWithRateDetailsDTO) => void;
}

const ReservationList = ({
  reservations,
  primaryColor,
  companyTimezone,
  checkInSettings,
  settings,
  onClick,
}: ReservationListProps) => {
  return (
    <VStack gap={2} width={'full'} cursor={'pointer'}>
      {reservations.map((reservation) => {
        return (
          <ReservationDetailsCard
            onClick={() => onClick?.(reservation)}
            key={`reservation_${reservation.id}`}
            reservation={reservation}
            primaryColor={primaryColor}
            listLayout
            companyTimezone={companyTimezone}
            checkInSettings={checkInSettings}
            settings={settings}
            showEditButton={false}
          />
        );
      })}
    </VStack>
  );
};

export default ReservationList;
